export const columns = [
  { field: 'product',       headerName: 'Producto',      flex: 2, align: 'center', headerAlign: 'center' },
  { field: 'category',      headerName: 'Categoría',     flex: 1, align: 'center', headerAlign: 'center' },
  { field: 'containerType', headerName: 'T. Contenedor', flex: 2, align: 'center', headerAlign: 'center', hiddenOnMobile: true },
  { field: 'unitType',      headerName: 'T. Unidad',     flex: 1, align: 'center', headerAlign: 'center', hiddenOnMobile: true },
];
  